import { Component, Input, ViewEncapsulation } from '@angular/core';
import { DrupalRichTextLinkDirective } from '@nx-massaud/utils';

@Component({
  selector: 'msd-det-ui-description',
  standalone: true,
  template: ` <div [innerHTML]="description" i2lDrupalRichTextLink></div> `,
  styleUrls: ['./description.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  imports: [DrupalRichTextLinkDirective],
})
export class DescriptionComponent {
  @Input()
  description: string | undefined;
}
